import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { modelData } from '../data/mock';

const HeroSection = () => {
  const [entered, setEntered] = useState(false);

  const handleEnter = () => {
    setEntered(true);
    setTimeout(() => {
      const introSection = document.getElementById('intro');
      if (introSection) {
        introSection.scrollIntoView({ behavior: 'smooth' });
      }
    }, 800);
  };

  return (
    <section
      id="welcome"
      className="relative min-h-screen flex items-center justify-center bg-black overflow-hidden"
    >
      {/* Background gradient */}
      <div className="absolute inset-0 bg-gradient-to-b from-black via-black/95 to-black" />
      
      {/* Decorative elements */}
      <div className="absolute top-0 left-0 w-full h-full">
        <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-pink-500/5 rounded-full blur-3xl animate-pulse" />
        <div className="absolute bottom-1/4 right-1/4 w-80 h-80 bg-pink-400/5 rounded-full blur-3xl animate-pulse delay-1000" />
      </div>

      {/* Content */}
      <div className={`relative z-10 text-center px-6 transition-all duration-1000 ${entered ? 'opacity-0 transform -translate-y-20' : 'opacity-100'}`}>
        {/* Main Title */}
        <h1 className="text-white text-4xl md:text-6xl lg:text-7xl font-extralight tracking-[0.15em] mb-6 leading-tight">
          {modelData.heroTitle.split(' ').map((word, index) => (
            <span
              key={index}
              className="inline-block animate-fade-in-up mr-4"
              style={{ animationDelay: `${index * 0.2}s` }}
            >
              {word}
            </span>
          ))}
        </h1>

        {/* Subtitle */}
        <p className="text-white/60 text-sm md:text-base tracking-[0.3em] mb-12 animate-fade-in-up" style={{ animationDelay: '0.8s' }}>
          {modelData.heroSubtitle.toUpperCase()}
        </p>

        {/* Enter Button */}
        <button
          onClick={handleEnter}
          className="group relative px-12 py-4 border border-pink-400/50 text-pink-400 text-sm tracking-[0.3em] hover:bg-pink-400 hover:text-black transition-all duration-500 animate-fade-in-up"
          style={{ animationDelay: '1s' }}
        >
          <span className="relative z-10">ENTER</span>
          <div className="absolute inset-0 bg-pink-400 transform scale-x-0 group-hover:scale-x-100 transition-transform duration-500 origin-left" />
          <span className="absolute inset-0 flex items-center justify-center text-black opacity-0 group-hover:opacity-100 transition-opacity duration-500 delay-200 tracking-[0.3em] text-sm">
            ENTER
          </span>
        </button>

        {/* Scroll indicator */}
        <div className="absolute bottom-10 left-1/2 transform -translate-x-1/2 animate-bounce">
          <ChevronDown className="text-white/30" size={32} />
        </div>
      </div>

      {/* Decorative line */}
      <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-pink-400/30 to-transparent" />
    </section>
  );
};

export default HeroSection;
